import React from 'react';
import { Redirect, Link, useParams } from 'react-router-dom';
import { Button, Alert } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Form, FormItem, Input, Checkbox } from 'formik-antd';
import { Formik } from 'formik';

import Client from 'containers/app/client';

import { getRoutePrefix } from 'utils/routes';
import { useUserWithRole } from 'hooks/custom-auth';
import { useDocument } from 'react-firebase-hooks/firestore';

import { LayoutPage } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';

import schema from './schema';
import initialValues from './initial-values';
import './style.css';

const Login = () => {
  const { id } = useParams();
  const [user, loadingUser, errorUser] = useUserWithRole(Client.auth);
  const ref = Client.dbProfile();
  const [profile, loadingProfile, errorProfile] = useDocument(ref);

  if (loadingUser) return <LoadingFullPage />;
  if (errorUser) throw errorUser;

  if (user) {
    if (loadingUser || loadingProfile) return null;
    if (errorUser || errorProfile) return null;
    if (!user) return null;

    const routePrefix = getRoutePrefix(user.claims.role);
    return <Redirect to={`${routePrefix}/dashboard`} />;
  }

  const handleSubmit = async (values, actions) => {
    try {
      const { email, password } = values;
      await Client.auth.signInWithEmailAndPassword(email, password);

      actions.setSubmitting(false);
    } catch (e) {
      actions.setSubmitting(false);
      actions.setStatus({ message: e.message, type: 'error' });
    }
  };

  return (
    <LayoutPage className="login-page">
      <LayoutPage.Container className="wrapper">
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={schema}
        >
          {({ isSubmitting, status, setStatus }) => {
            return (
              <Form layout="vertical" className="wrapper">
                {status ? (
                  <Alert
                    closable
                    message={status.message}
                    type={status.type}
                    onClose={() => {
                      setStatus(undefined);
                    }}
                  />
                ) : null}
                <FormItem name="email" label="Email">
                  <Input
                    type="email"
                    name="email"
                    prefix={<MailOutlined />}
                    placeholder="Email"
                  />
                </FormItem>
                <FormItem name="password" label="Password">
                  <Input
                    type="password"
                    name="password"
                    prefix={<LockOutlined />}
                    placeholder="Password"
                  />
                </FormItem>
                <FormItem name="remember">
                  <Checkbox name="remember">Remember me</Checkbox>
                  <Link to="/forgot-password">Forgot password</Link>
                </FormItem>
                <Button
                  style={{ width: '100%' }}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  Log in
                </Button>
                <span className="register-message">
                  Or <Link to={`/signup/${id}`}>register now!</Link>
                </span>
              </Form>
            );
          }}
        </Formik>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

Login.propTypes = {};

export default Login;
